<template>
    <div class="reward-tab body-item ">

        <div class="title"></div>

        <div class="tab-hd">
            <div class="u-btn" v-for="(item,index) in config.tab_hd"
            :key="index"
            :class="[{act : index == now},'t-' + (index + 1)]"
            @click="now=index">{{ item }}</div>
        </div>

        <div class="tab-view">
            <div class="tab-item r-1" v-show="now == 0">
                <div class="container">
                    <div class="reward-cash">

                    </div>

                    <div class="reward-game">
                        <div class="game-item game-title">
                            <ul>
                                <li v-for="(item,index) in reward_data.game_title" :key="index">
                                    <div class="title-name">称号：{{ item.title }}</div>
                                    <div class="title-detail">{{ item.content }}</div>
                                </li>
                            </ul>
                        </div>
                        <div class="game-item">
                            <div class="reward-item" v-for="(list,index) in reward_data.game_reward" :key="index">
                                <div class="icon i-pos" :class="'p-'+ (index + 1)"></div>
                                <ul>
                                    <li v-for="(item,k) in list" :key="k">

                                        <div class="pic" v-if="item.tip"
                                            @mouseover="$tips_on($event,item.tip,'img')"
                                            @mouseleave="$tips_off()"
                                        >
                                            <div class="icon">
                                                <img :src="require('@/assets/images/items/' + item.id + '.jpg')" alt="" srcset="">
                                            </div>                                                 
                                        </div>

                                        <div class="pic" v-else>
                                            <div class="icon">
                                                <img :src="require('@/assets/images/items/' + item.id + '.jpg')" alt="" srcset="">
                                            </div>                                              
                                        </div>  

                                    </li>
                                </ul>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-item r-2" v-show="now == 1">
                <div class="reward-city"></div>

                <div class="reward-city-game">
                    <div class="slogen"></div>
                    <div class="reward-view">
                        <ul>
                            <li v-for="(item,index) in reward_data.offline_reward" :key="index">
                                <div class="pic" v-if="item.tip"
                                    @mouseover="$tips_on($event,item.tip,'img')"
                                    @mouseleave="$tips_off()"
                                >
                                    <div class="icon">
                                        <img :src="require('@/assets/images/items/' + item.id + '.jpg')" alt="" srcset="">
                                    </div>                                                 
                                </div>

                                <div class="pic" v-else>
                                    <div class="icon">
                                        <img :src="require('@/assets/images/items/' + item.id + '.jpg')" alt="" srcset="">
                                    </div>                                              
                                </div>   
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>


    .reward-tab{
        width: 100%;
        /* height: 1659px; */
        height: 1000px;
        margin: 0 auto;
        padding-top: 40px;
        background-image: url(~@/assets/images/bg-reward.jpg); 
        background-position: center;
        background-repeat: no-repeat;
        box-sizing: border-box;  
    }


    .title{
        width: 1113px;
        height: 170px;
        margin: 0 auto;
        background-image: url(~@/assets/images/title-2.png);
    }

    .tab-hd{
        display: flex;
        justify-content: space-between;
        /* padding: 0 45px; */
        width: 1388px;
        height: 57px;
        margin: 45px auto 0;
        /* background-image: url(~@/assets/images/faker.png); */
        box-sizing: border-box;
        border: 1px solid #b28850;
    }

    .tab-hd .u-btn{
        width: 50%;
        height: 55px;
        line-height: 55px;
        font-size: 28px;
        text-align: center;       
        color: #ffe0ba;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(~@/assets/images/btn-tab_normal.png);
    }

    .tab-hd .u-btn.act{
        color: #653715;
        background-image: url(~@/assets/images/btn-tab.png);
    }

    /* .u-btn.t-1{
        background-image: url(../assets/images/tab-r-1.png);
    }

    .u-btn.t-1.act{
        background-image: url(../assets/images/tab-r-1-act.png);
    }    

    .u-btn.t-2{
        background-image: url(../assets/images/tab-r-2.png);
    }
    
    .u-btn.t-2.act{
        background-image: url(../assets/images/tab-r-2-act.png);
    } */
    
    .tab-view{
        width: 1388px;
        margin: 30px auto 0;
        /* background-image: url(../assets/images/bg-tab.png); */
    }

    .tab-img{
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
    }


    .tab-item.r-1 .container{
        display: flex;
        justify-content: space-between;       
    }

    .reward-cash{
        width: 512px;
        height: 573px;
        background-image: url(~@/assets/images/online-r-1.png);
    }

    .reward-game{
        display: flex;
        justify-content: space-between;
        width: 830px;
        height: 573px;
        padding: 80px 40px 0 47px;
        box-sizing: border-box;        
        background-image: url(~@/assets/images/online-r-2.png);
    }
    
    .reward-city{
        width: 1098px;
        height: 311px;
        margin:  0 auto;
        background-image: url(~@/assets/images/img-offline.png);
    }

    .reward-city-game{
        margin-top: 45px;
    }

    .reward-city-game .slogen{
        width: 530px;
        height: 27px;
        margin: 0 auto;
        background-image: url(~@/assets/images/slogen-3.png);           
    }

    .reward-city-game .reward-view{
        width: 1401px;
        height: 166px;
        margin: 35px auto 0;
        background-image: url(~@/assets/images/bg-offline-r.png);    
    }

    .reward-view ul{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .reward-view li{
        position: relative;
        width: 84px;
        height: 84px;
        margin: 0 17.5px;
        background-image: url(~@/assets/images/bg-item.png);  
    }

    .reward-view .pic{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 46px;
        height: 46px;
        transform: translate(-50%,-50%);
    }


    .game-title ul{
        width: 270px;
    }

    .game-title li{
        display: flex;
        margin-top: 30px;
        padding-bottom: 20px;
        font-size: 14px;
        color: #cf9f60;
        justify-content: space-between;
        align-items: center;
        border-bottom: .5px solid #795f3b;
    }

    .title-name{
        width: 117px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        font-weight: 700;
        color: #522e13;
        background-image: url(~@/assets/images/bg-game-title.png); 
    }

    .reward-item{
        display: flex;
        width: 382px;
        height: 68px;
        margin-bottom: 8px;
        background-image: url(~@/assets/images/bg-game-reward.png); 
        justify-content: flex-start;
        align-items: center;
    }

    .reward-item ul{
        display: flex;
    }

    .reward-item li{
        position: relative;
        width: 54px;
        height: 54px;
        margin: 0 6px;
        background-image: url(~@/assets/images/bg-item_2.png); 
    }

    .reward-item .pic{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 46px;
        height: 46px;
        transform: translate(-50%,-50%);
    }

    .i-pos{
        width: 77px;
        height: 55px;
        margin-left: 8px;
        margin-right: 27px;
        background-image: url(~@/assets/images/icon-pos_1.png); 
    }

    .i-pos.p-1{
       background-image: url(~@/assets/images/icon-pos_1.png); 
    }

    .i-pos.p-2{
       background-image: url(~@/assets/images/icon-pos_2.png); 
    } 
    
    .i-pos.p-3{
       background-image: url(~@/assets/images/icon-pos_3.png); 
    }
    
    .i-pos.p-4{
       background-image: url(~@/assets/images/icon-pos_4.png); 
    }
    
    .i-pos.p-5{
       background-image: url(~@/assets/images/icon-pos_5.png); 
    }
    
    .i-pos.p-6{
       background-image: url(~@/assets/images/icon-pos_6.png); 
    }      
</style>

<script>
export default {
    data (){
        return {
            config : {
                tab_hd : ['线上选拔赛','城市选拔赛'],
                tab_bd : [{
                    img : require("@/assets/images/tab-img-1.png"),
                },{
                    img : require("@/assets/images/tab-img-2.png"),
                }]
            },
            now : 0,
            reward_data : {
                game_title : [
                    {title : '烽火擒将', content : '烽火杯总击杀第一获得'},
                    {title : '烽火富贾', content : '烽火杯总经济第一获得'},
                    {title : '烽火神助', content : '烽火杯总助攻第一获得'},
                    {title : '烽火破防', content : '烽火杯总拆塔第一获得'},
                    {title : '烽火屠戮', content : '烽火杯总补兵第一获得'},
                    {title : '烽火霸主', content : '烽火杯总最佳第一获得'},
                ],
                game_reward : [
                    [{id : 'a1',num : 1},{id : 'a2',num : 1},{id : 'a3',num : 1},{id : 'a4',num : 1,tip : 't1'},],
                    [{id : 'b1',num : 1},{id : 'b2',num : 1},{id : 'b3',num : 1},{id : 'b4',num : 1,tip : 't1'},],
                    [{id : 'c1',num : 1},{id : 'c2',num : 1},{id : 'c3',num : 1},{id : 'c4',num : 1,tip : 't1'},],
                    [{id : 'd1',num : 1,tip : 't1'},{id : 'd2',num : 1,tip : 't5'},],
                    [{id : 'e1',num : 1,tip : 't1'},{id : 'e2',num : 1,tip : 't5'},],
                    [{id : 'f1',num : 1,tip : 't5'},{id : 'f2',num : 1,tip : 't2'},{id : 'f3',num : 1,tip : 't3'},],
                ],
                offline_reward : [{id : 'g1',num : 1,tip : 't5'},{id : 'g2',num : 1,tip : 't2'},{id : 'g3',num : 1,tip : 't3'},{id : 'g4',num : 1,tip : 't4'},],
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/rewardTab.vue